var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNovusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.82 81.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#002957;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Novus_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.11 8.79 10.76 8.51 7.51 12.28 82.88 72.5 83.22 72.78 86.47 69.01 11.11 8.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.88,17.24,3.53,17,.34,20.67l.1.08h0l.34.3C7.1,26.71,10.39,34.7,9.58,42.44A18.86,18.86,0,0,1,.4,57.15l-.4.23,2.35,4.1.4-.23A23.5,23.5,0,0,0,14.28,42.93a28.31,28.31,0,0,0-1.53-12.37L75.53,81.15l.35.28,3.25-3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M93.4,60.51l-.35-.31c-6.32-5.64-9.62-13.63-8.8-21.37a18.82,18.82,0,0,1,9.17-14.71l.4-.23-2.34-4.11-.41.23A23.53,23.53,0,0,0,79.54,38.33a28.19,28.19,0,0,0,1.54,12.38L17.94.05,14.69,3.82,89.94,64l.35.28,3.2-3.71-.1-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.91,42.69C19,51.82,14.51,63,6.18,67.09l-.44.22,2.49,4.32.39-.2c7.93-4.1,14-13.82,15.89-25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.46,50.32C27.24,62.67,18.85,73.07,11.81,76.73l-.43.22,2.49,4.32.4-.21c8.78-4.63,16.62-15.68,19.52-27.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.93,38.29c.95-9.07,5.47-20,13.71-24.12l.44-.22L85.59,9.64l-.39.2C77.34,13.9,71.26,23.5,69.36,34.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.41,30.68C66.7,18.45,75,8.17,82,4.54l.43-.23L80,0l-.39.21C70.84,4.8,63,15.72,60.09,27.23Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovusIcon);
export default __webpack_public_path__ + "static/media/Novus_icon.25403a5eb86340cf63b49e56a47499e5.svg";
export { ForwardRef as ReactComponent };